import * as Redux from 'redux'
import * as Types from './types'
import * as Utils from './utils'

export type Toggle = () => Redux.Action
export type Close = () => Redux.Action
export type Reset = () => Redux.Action

export interface UpdateFieldAction extends Redux.Action { field: Types.ModalField }
export type Update = (field: Types.ModalField) => UpdateFieldAction

export type Submit<T> = (community: string, data: T) => Redux.Action
export type SubmitWithId<T> = (id: Types.Id, community: string, data: T) => Redux.Action

export const resetModal = (prefix: string): Reset => () => ({type: Utils.resetModalConstant(prefix)})
export const toggleModal = (prefix: string): Toggle => () => ({type: Utils.toggleModalConstant(prefix)})
export const closeModal = (prefix: string): Toggle => () => ({type: Utils.closeModalConstant(prefix)})
export const updateModal = (prefix: string): Update => (field: Types.ModalField) =>
  ({type: Utils.updateModalConstant(prefix), field})



// WEBPACK FOOTER //
// ./src/components/modal/actions.ts